export const countries: CountryType[] = [
  {
    id: 2,
    value: 'german',
    countryName: 'German',
    countryFlagUrl: '/german.png',
    code: 'DE',
  },
  {
    id: 1,
    value: 'austria',
    countryName: 'Austria',
    countryFlagUrl: '/countries/at.png',
    code: 'AT',
  },
  {
    id: 3,
    value: 'Switzerland',
    countryName: 'Switzerland',
    countryFlagUrl: '/countries/ch.png',
    code: 'CH',
  },
];

export const languages: LanguageType[] = [
  {
    key: 'de',
    title: 'German',
  },
  {
    key: 'en',
    title: 'English',
  },
];

export type LanguageType = {
  key: string;
  title: string;
};

export type CountryType = {
  id: number | string;
  value: string;
  countryName: string;
  countryFlagUrl: string;
  code: string;
};
